import { palette } from '@roleypoly/design-system/atoms/colors';
import styled from 'styled-components';

export const TextStyle = styled.div`
  color: ${palette.taupe500};
`;
